module.exports = __webpack_public_path__ + "img/logo_huatu.3be79783.png";